import { FaSpinner } from "react-icons/fa";

function Spinner({ className }: { className?: string }) {
    return <div className={`spinner ${className}`}><FaSpinner /></div>;
}

export default Spinner;
